module.exports = __webpack_public_path__ + "img/Partners9.ae2ba7e5.png";